"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageViewer = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_useimage_1 = __importDefault(require("@opsbase/react-useimage"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const useResolvedImages_1 = __importDefault(require("../useResolvedImages"));
const makeMyClasses = size => ({
    image: {
        width: size,
        display: 'inline-block',
        marginLeft: 6,
        cursor: 'pointer',
        backgroundColor: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
        borderRadius: 8,
    },
    spinner: {
        position: 'relative',
        left: size / 3,
        top: size / 6,
    },
    cancelButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: '0 8px',
        zIndex: 100,
        height: 24,
        minWidth: 24,
    },
});
const callbackReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { [action.key]: action.callback });
};
function ImageViewer(props) {
    const { fileNames, resolvedImages, size = 100, disableClick = false, useFull = false, editable, onDeleteImage, } = props;
    const { getFullImageUrlByFileName } = (0, react_useimage_1.default)();
    const displayImages = (0, useResolvedImages_1.default)(fileNames, resolvedImages, useFull);
    const myCss = (0, web_css_1.default)(makeMyClasses, [size]);
    const [callbacks, callbackDispatch] = (0, react_1.useReducer)(callbackReducer, {});
    const showPreview = (0, react_1.useCallback)((index) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const image = displayImages[index];
        const fullImageUrl = (_b = (_a = image.imageData) !== null && _a !== void 0 ? _a : image.url) !== null && _b !== void 0 ? _b : (yield getFullImageUrlByFileName(image.fileName));
        showFullImg(fullImageUrl);
    }), [displayImages, getFullImageUrlByFileName]);
    const deleteImage = (0, react_1.useCallback)((index, e) => __awaiter(this, void 0, void 0, function* () {
        e.stopPropagation();
        onDeleteImage === null || onDeleteImage === void 0 ? void 0 : onDeleteImage(index);
    }), [onDeleteImage]);
    const getImageCallback = (0, react_1.useCallback)((prefix, index, fn) => {
        const key = `${prefix}_${index}`;
        let c = callbacks[key];
        if (!c) {
            c = e => fn(index, e);
            callbackDispatch({ key, callback: c });
        }
        return c;
    }, [callbacks]);
    return (react_1.default.createElement(Horizontal_1.default, { flexWrap: "wrap", justify: "flex-start", gutter: true }, displayImages === null || displayImages === void 0 ? void 0 : displayImages.map((dispImage, index) => {
        var _a, _b;
        const url = (_b = (_a = dispImage.imageData) !== null && _a !== void 0 ? _a : dispImage.thumbnailUrl) !== null && _b !== void 0 ? _b : dispImage.url;
        return (react_1.default.createElement("div", { key: `image_${index}`, style: { position: 'relative' } },
            react_1.default.createElement("img", { alt: "", src: url, className: myCss.image, onClick: disableClick
                    ? undefined
                    : getImageCallback('preview', index, showPreview) }),
            editable && !!onDeleteImage ? (react_1.default.createElement(Button_1.default, { small: true, classes: { root: myCss.cancelButton }, icon: react_1.default.createElement(DeleteIcon_1.default, { size: 16 }), color: lib_palette_1.default.BadRed, onClick: getImageCallback('delete', index, deleteImage) })) : null,
            dispImage.loading ? (react_1.default.createElement("div", { className: myCss.spinner },
                react_1.default.createElement(core_1.CircularProgress, { disableShrink: true, variant: "indeterminate", size: size / 3 }))) : null));
    })));
}
exports.ImageViewer = ImageViewer;
exports.default = ImageViewer;
function showFullImg(imgSrc) {
    const strWindowFeatures = `scrollbars=yes,width=1000,height=800`;
    const newImg = window.open('', 'myImg', strWindowFeatures);
    newImg.document.write(`
		<html lang="en">
		<head>
		<link rel="stylesheet" href="./assets/fonts/style.css"/><title>Full Image</title>
		</head>
		<body style="background: ${lib_palette_1.default.BackgroundGrey.main}"><div>
			<div style="text-align: center">
				<a
					download="image.jpg"
					href="${imgSrc}"
					style="
						font-family: 'Gilroy',serif;
						line-height: 24px;
						background: ${lib_palette_1.default.primary.main};
						color: white !important;
						padding: 8px;
						margin: 8px auto 8px auto;
						border-radius: 8px;
						display: block;
						width: 200px;
						text-align: center;
						text-decoration: none;
					"
				>${lib_i18n_1.default.t('click-to-download')}</a>
			</div>
			<br />
			<img
				alt=""
				src="${imgSrc}"
				style="
					background: white;
					display:block;
					max-width:100%;
					max-height:100%;
					width:auto;
					height:auto;
					margin-left:auto;
					margin-right:auto;
					border-width: 1px
					border-style: solid
					border-color: ${lib_palette_1.default.LavendarGrey.main};
					box-shadow: 0 0 20px -4px ${lib_palette_1.default.BlackCoral.main};
				"
			/>
		</div></body>
		</html>`);
    // newImg.document.write(
    // 	`<script type='text/javascript'>
    // 			document.oncontextmenu = new Function("return false")
    // 	</script>`
    // )
    newImg.document.close();
}
